async function postJson<T>(path: string, body: unknown): Promise<T> {
  const res = await fetch(path, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`hub ${path} failed: ${res.status}`);
  return (await res.json()) as T;
}

export async function requestCode(email: string): Promise<void> {
  await postJson("/api/hub/request-code", { email });
}

export function verifyHub(input: { email: string; code?: string; linkToken?: string }): Promise<{
  hubSession: string;
  orgs: Array<{ slug: string; displayName: string }>;
  pendingOnly: boolean;
}> {
  return postJson("/api/hub/verify", input);
}

export function enterOrg(hubSession: string, slug: string): Promise<{ customToken: string }> {
  return postJson("/api/hub/enter", { hubSession, slug });
}
